import React from "react";
import useSeo from "../hooks/useSeo";

const ROWS = [
  { size: "S", chest: "38", length: "27", shoulder: "17", sleeve: "8" },
  { size: "M", chest: "40", length: "28", shoulder: "18", sleeve: "8.5" },
  { size: "L", chest: "42", length: "29", shoulder: "19", sleeve: "9" },
  { size: "XL", chest: "44", length: "30", shoulder: "20", sleeve: "9.5" },
  { size: "XXL", chest: "46", length: "31", shoulder: "21", sleeve: "10" },
];

const SizeGuide = () => {
  useSeo({ title: "Size Guide", description: "9'One Store size guide with placeholder measurements for S–XXL t-shirts.", path: "/size-guide" });
  return (
    <div className="animate-fade-in">
      <div className="border-b border-ink">
        <div className="container-9one py-12">
          <p className="label-mono text-ink/50">Find your fit</p>
          <h1 className="mt-2 font-display text-5xl uppercase tracking-tight sm:text-7xl">Size Guide</h1>
        </div>
      </div>

      <div className="container-9one max-w-3xl py-12">
        <p className="mb-6 font-mono text-[11px] uppercase tracking-wider text-ink/50">
          Placeholder measurements (inches) — to be confirmed with real specs
        </p>
        <div className="overflow-x-auto border border-ink">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="border-b border-ink bg-ink text-paper">
                {["Size", "Chest", "Length", "Shoulder", "Sleeve"].map((h) => (
                  <th key={h} className="label-mono px-4 py-3 text-left text-paper">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r) => (
                <tr key={r.size} className="border-b border-ink/10 last:border-0">
                  <td className="px-4 py-3 font-mono font-medium">{r.size}</td>
                  <td className="px-4 py-3 font-mono text-ink/70">{r.chest}"</td>
                  <td className="px-4 py-3 font-mono text-ink/70">{r.length}"</td>
                  <td className="px-4 py-3 font-mono text-ink/70">{r.shoulder}"</td>
                  <td className="px-4 py-3 font-mono text-ink/70">{r.sleeve}"</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-8 space-y-2 text-sm leading-relaxed text-ink/60">
          <p><strong className="text-ink">How to measure:</strong> Lay a similar t-shirt flat and measure across.</p>
          <p><strong className="text-ink">Chest:</strong> Measured pit-to-pit, then doubled.</p>
          <p><strong className="text-ink">Between sizes?</strong> Size up for a relaxed / oversized fit.</p>
          <p className="text-ink/40">Final measurements will be updated with real product specifications.</p>
        </div>
      </div>
    </div>
  );
};

export default SizeGuide;
